import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { MainContent } from './MainContent'
import { RealTimeBlocks } from './RealTimeBlocks'
export const Fr=()=> {
  return (
    <>
    <MainDiv>
    {/* <RealTimeBlocks/> */}
    <MainContent/>
    </MainDiv>
    </>
    
  )
}
